import { INewCardLocalStorage, NEW_CARD_LOCALSTORAGE } from '../types';

export const getNewCardLocalStorage = (
): INewCardLocalStorage => {
    const data = localStorage.getItem(NEW_CARD_LOCALSTORAGE);
    return data ? JSON.parse(data) : {};
}
